
import React from 'react';
import { CosmosLogoIcon } from './icons/CosmosLogoIcon';
import { ArrowRightWhiteIcon } from './icons/ArrowRightWhiteIcon';

interface EmptyInboxProps {
    onGoToCosmos: () => void;
}

export const EmptyInbox: React.FC<EmptyInboxProps> = ({ onGoToCosmos }) => {
    return (
        <div className="flex flex-col items-center gap-10">
            <div className="w-20 h-20">
                <CosmosLogoIcon />
            </div>
            <div className="flex flex-col items-center gap-2 self-stretch">
                <h2 className="text-grayscale-1300 text-center font-grotesk text-2xl font-bold">
                    You haven’t contacted any universities yet!
                </h2>
                <p className="text-grayscale-1100 font-grotesk text-sm font-normal text-center">
                    Explore some of the world’s best technology, all in one place.
                </p>
            </div>
            <div className="w-80">
                <button
                    onClick={onGoToCosmos}
                    className="flex py-2.5 px-4 justify-center items-center gap-2 flex-1 rounded-full bg-primary-og-600 shadow-custom-light w-full"
                >
                    <span className="text-white text-center font-grotesk text-sm font-medium">
                        Go to Cosmos
                    </span>
                    <ArrowRightWhiteIcon />
                </button>
            </div>
        </div>
    );
};
